import pickerStyles from "./monday-import-items-picker.module.css";
import { MondayStyledDropdownPicker } from "frontend/ui-components/picker/monday-styled-dropdown-picker/monday-styled-dropdown-picker";
import { ResourceItem } from "frontend/canvas-designer-new/monday-import-items/resource-item/resource-item";
import { ResourceType } from "frontend/canvas-designer-new/monday-import-items/monday-import-items.types";
import { CSSProperties } from "react";

type MondayImportItemsPickerProps = {
  options: ResourceType[];
  selectedOption: ResourceType | null;
  setSelectedOption: (workspace: ResourceType) => void;
  showIcon?: boolean;
  fetchMore?: () => void;
  loadingMore?: boolean;
  isLoading?: boolean;
  type: "workspace" | "board";
  placeholder?: string;
  isOptionDisabled?: (option: ResourceType) => boolean;
  disabledTooltip?: string;
  pickerTitle: string;
  pickerStyle?: CSSProperties;
  pickerWidth?: string;
  useFloatingDropdown?: boolean;
  trackingEventName: string;
  onSearch?: (search: string) => void;
};

export const MondayImportItemsPicker = ({
  options,
  selectedOption,
  setSelectedOption,
  showIcon = true,
  fetchMore,
  loadingMore = false,
  isLoading = false,
  type,
  placeholder,
  isOptionDisabled,
  disabledTooltip,
  pickerTitle,
  pickerStyle,
  pickerWidth = "156px",
  useFloatingDropdown = false,
  trackingEventName,
  onSearch,
}: MondayImportItemsPickerProps) => {
  const defaultPlaceholder = type === "workspace" ? "Select workspace" : "Select board";

  return (
    <div style={{ width: pickerWidth }}>
      <div className={pickerStyles.pickerTitle} style={pickerStyle}>
        {pickerTitle}
      </div>
      <MondayStyledDropdownPicker<ResourceType>
        options={options}
        selectedOption={selectedOption}
        onChange={setSelectedOption}
        isSelected={(v) => v.id === selectedOption?.id}
        getTitle={(option) => option.name}
        renderOption={(option) => (
          <ResourceItem
            resource={option}
            variant="option"
            showIcon={showIcon}
            type={type}
            disabled={isOptionDisabled?.(option) ?? false}
            disabledTooltip={disabledTooltip}
          />
        )}
        renderSelectedOption={(option) => {
          if (!option) return <></>;
          return <ResourceItem resource={option} variant="header" showIcon={showIcon} type={type} />;
        }}
        placeholder={placeholder || defaultPlaceholder}
        isLoading={isLoading}
        width={pickerWidth}
        enableSearch={true}
        searchPlaceholder="Search..."
        onFetchMore={fetchMore}
        loadingMore={loadingMore}
        isOptionDisabled={isOptionDisabled}
        includeOverlay={options.length > 3}
        useFloatingDropdown={useFloatingDropdown}
        onSearch={onSearch}
        trackingEventName={trackingEventName}
      />
    </div>
  );
};
